module.exports = __webpack_public_path__ + "img/SKUworld-logo-v2.0500286a.png";